import type { CityConfig } from "../city-template/types";

export const columbusOhConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Franklin County Probate Court", href: "https://www.franklincountyohio.gov/probate", description: "Franklin County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Franklin County Clerk of Courts", href: "https://www.fccourtclerk.com/", description: "Franklin County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Columbus",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "columbus-oh",
  route: "/cities/columbus-oh",
  title: "Emergency Passport Columbus, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Columbus, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Franklin County and the Columbus metro area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Columbus, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Columbus and the Greater Columbus metro area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Columbus%20Ohio%20downtown%20skyline%20at%20golden%20hour%20with%20the%20stunning%20Ohio%20Statehouse%20capitol%20building%20dome%20illuminated%20in%20warm%20amber%20light%2C%20modern%20skyscrapers%20rising%20behind%20the%20historic%20capitol%2C%20the%20Scioto%20River%20and%20Discovery%20Bridge%20visible%20in%20the%20foreground%2C%20vibrant%20sunset%20colors%20reflecting%20on%20glass%20buildings%2C%20professional%20cityscape%20photography%20wide%20panoramic%20view&width=1800&height=700&seq=columbus-oh-hero-001&orientation=landscape",
  heroImageAlt: "Columbus Ohio downtown skyline at golden hour with Ohio Statehouse capitol building",
  geoPosition: "39.9612;-82.9988",
  geoPlacename: "Columbus, Ohio",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 350 miles from Columbus via I-65",
  },
  nearbyCitiesZips: [
    { name: "Columbus", zips: "43201–43299" },
    { name: "Dublin", zips: "43016, 43017, 43021" },
    { name: "Westerville", zips: "43081, 43082, 43086" },
    { name: "Worthington", zips: "43085" },
    { name: "Upper Arlington", zips: "43220, 43221" },
    { name: "Gahanna", zips: "43230" },
    { name: "Reynoldsburg", zips: "43068" },
    { name: "Hilliard", zips: "43026" },
    { name: "Grove City", zips: "43123" },
    { name: "Pickerington", zips: "43147" },
    { name: "Newark", zips: "43055, 43056, 43058" },
    { name: "Lancaster", zips: "43130, 43138" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Columbus departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-flight-takeoff-line", title: "Airport Proximity", desc: "Serving CMH and surrounding Central Ohio travelers" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Dayton, OH", route: "/dayton" },
    { name: "Fast passport renewal in Cincinnati, OH", route: "/cities/cincinnati" },
    { name: "Emergency passport help in Cleveland, OH", route: "/cities/cleveland" },
    { name: "Urgent passport services in Dublin, OH", route: "/cities/dublin-oh" },
    { name: "Same-day passport help in Newark, OH", route: "/cities/newark-oh" },
    { name: "Passport courier services in Reynoldsburg", route: "/cities/reynoldsburg" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Columbus remotely via secure courier. We do not have a walk-in office in Columbus — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Franklin County and Central Ohio travelers.",
  fpcOfficeAddress: "312 Walnut St, Cincinnati, OH 45202",
  fpcOfficeDistance: "Serving all of Franklin County and the greater Central Ohio region",
  serviceAreaIntro: "From downtown Columbus to the suburbs of Dublin, Westerville, and Upper Arlington, from the Short North to Pickerington and Grove City — Fast Passport Center serves the entire Greater Columbus metro area. We regularly help travelers from Hilliard, Reynoldsburg, and Gahanna get their passports fast.",
  nearbyCitiesIntro: "We serve all Columbus neighborhoods and surrounding Central Ohio communities including Dublin, Westerville, Worthington, Upper Arlington, Gahanna, Reynoldsburg, Hilliard, Grove City, Pickerington, Newark, Lancaster, and beyond. If you are anywhere in Franklin, Delaware, Licking, Fairfield, or Pickaway counties, we have you covered.",
  howItWorksIntro: "Most Columbus travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Columbus travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Columbus and Central Ohio travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Columbus? Here are the most common ones we hear from Franklin County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Columbus international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "James W.",
      location: "Columbus, OH",
      rating: 5,
      text: "Got my passport renewed in 3 business days for a business trip to London. The entire process was handled online. Fast Passport Center is the real deal.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda K.",
      location: "Dublin, OH",
      rating: 5,
      text: "Emergency passport for a family situation abroad. They expedited mine in 36 hours. Compassionate, fast, and incredibly professional team.",
      service: "Emergency Passport",
    },
    {
      name: "Chris M.",
      location: "Westerville, OH",
      rating: 5,
      text: "First passport ever and I had no idea where to start. Fast Passport Center guided me through everything — found my acceptance facility and delivered in 5 days.",
      service: "New Passport",
    },
    {
      name: "Diane P.",
      location: "Upper Arlington, OH",
      rating: 5,
      text: "Our twins needed passports for a graduation trip to Europe with only 8 days' notice. Two passports, both delivered in 4 business days. Incredible service.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "columbus-oh-1",
      name: "Columbus Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "850 Twin Rivers Dr",
      city: "Columbus",
      state: "OH",
      zip: "43216",
      phone: "(614) 469-4357",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Near downtown Columbus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Columbus facility. Appointments required. High volume — book early.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-oh-2",
      name: "Worthington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "700 High St",
      city: "Worthington",
      state: "OH",
      zip: "43085",
      phone: "(614) 885-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Columbus suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north Columbus and Worthington residents. Shorter waits than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-oh-3",
      name: "Dublin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "37 S High St",
      city: "Dublin",
      state: "OH",
      zip: "43017",
      phone: "(614) 792-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northwest Columbus suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Dublin, Hilliard, and northwest Columbus residents. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-oh-4",
      name: "Reynoldsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1150 Brice Rd",
      city: "Reynoldsburg",
      state: "OH",
      zip: "43068",
      phone: "(614) 868-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Columbus suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for east Columbus, Pickerington, and Gahanna residents.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-oh-5",
      name: "Franklin County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "373 S High St",
      city: "Columbus",
      state: "OH",
      zip: "43215",
      phone: "(614) 525-3600",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Columbus, Franklin County Courthouse",
      website: "https://www.fccourtclerk.com/",
      websiteLabel: "Franklin County Clerk",
      notes: "Full passport services in downtown Columbus. Appointment recommended. Extended hours available.",
      icon: "ri-government-line",
    },
    {
      id: "columbus-oh-6",
      name: "Grove City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3300 Park St",
      city: "Grove City",
      state: "OH",
      zip: "43123",
      phone: "(614) 875-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Columbus suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves south Columbus and Grove City area. Less crowded than downtown options.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, limited slots in Chicago", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 350 mile drive to Chicago via I-65", fpc: "Most Columbus travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Columbus-Specific Guidance", agency: "Generic — no Ohio State, CMH airport, or corporate expertise", fpc: "Full Columbus/Chicago courier/OSU corporate knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Columbus photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Franklin County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Columbus applicants arrive with incorrect payment and must reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or provide notarized consent. This trips up many Columbus families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Columbus travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Columbus." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Columbus address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Columbus, Ohio before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Columbus, OH for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Columbus, OH?", a: "Fast Passport Center offers fast passport renewal in Columbus, Ohio in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Columbus, Ohio?", a: "The nearest regional passport agency to Columbus, Ohio is the Chicago Passport Agency, approximately 360 miles away via I-70. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Columbus." },
    { q: "Can I expedite a child passport in Columbus, Ohio?", a: "Yes. Fast Passport Center expedites child passports in Columbus, Ohio for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What neighborhoods in Columbus do you serve?", a: "We serve all Columbus neighborhoods and suburbs including the Short North, German Village, Clintonville, Dublin, Westerville, Upper Arlington, Worthington, Gahanna, Hilliard, Grove City, Reynoldsburg, and Pickerington. If you are in Franklin County or the surrounding Central Ohio region, we cover you." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Short North Columbus", address: "780 N High St, Columbus, OH 43215", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Dublin", address: "7455 Sawmill Rd, Dublin, OH 43016", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Columbus", address: "1 E Gay St, Columbus, OH 43215", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "Walmart Supercenter — Reynoldsburg", address: "2000 Brice Rd, Reynoldsburg, OH 43068", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Westerville", address: "950 N State St, Westerville, OH 43082", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Upper Arlington", address: "2200 W Henderson Rd, Columbus, OH 43220", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Grove City", address: "3470 Broadway, Grove City, OH 43123", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "AAA Travel — Columbus", address: "3900 Morse Rd, Columbus, OH 43219", hours: "Mon–Fri: 8AM–5:30PM", website: "https://www.aaa.com/" },
  ],
  dmvLocations: [
    {
      name: "Franklin County BMV — Columbus",
      address: "4010 W Broad St, Columbus, OH 43228",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Franklin County BMV — Easton",
      address: "3965 Morse Rd, Columbus, OH 43219",
      hours: "Mon–Fri: 8AM–5PM",
      note: "East side Columbus option. Shorter wait times than downtown. REAL ID available.",
      featured: false,
    },
    {
      name: "Delaware County BMV",
      address: "1 E Winter St, Delaware, OH 43015",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Dublin, Westerville, and Delaware County residents.",
      featured: false,
    },
    {
      name: "AAA Driver Services — Columbus",
      address: "3900 Morse Rd, Columbus, OH 43219",
      hours: "Mon–Fri: 8AM–5:30PM, Sat: 9AM–12PM",
      note: "AAA members can access licensing services and passport photos. Shorter waits than government BMV.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "10 miles from downtown Columbus",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Primary international airport serving Central Ohio. Direct flights to Europe and major domestic hubs.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "CMH Airport",
      featured: true,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "70 miles southwest of Columbus",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Alternative airport for west Columbus area travelers. Good domestic connections with easier parking.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "150 miles northeast of Columbus",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Major hub for additional international routes. Consider for long-haul trips.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
  ],
};